<template>
  <b-card no-body class="bg-white border mb-2 hover">
    <b-card-body class="p-2">
      <b-row align-h="start">
        <b-col>
          <h5 class="fw-bolder m-0" :disabled="enabledTranslate || isLang"
              @mouseenter="translate(title)"
              @focusin="translate(title)" v-b-tooltip.hover
              :title="!enabledTranslate ? translateObject : ''">{{ count }}.
            <a href="#" @click.prevent="searchJob" v-b-toggle.jobs-sidebar
               class="link-primary stretched-link">
              <span>{{title}}</span>
            </a>
          </h5>
          <small class="translate-title" v-if="enabledTranslate" :content="allTranslate(title)">
            {{ translateObject }}
          </small>
        </b-col>
        <b-col cols="auto" class="ml-auto">
          <b-button v-if="!active" @click="setNotepad" size="sm" variant="primary" class="position-relative z-3" v-b-modal="!isAuth ? 'not-auth-modal' : ''">
            <span v-b-tooltip.hover.bottom :title="translations[13596]">
              <b-icon icon="star-fill"></b-icon>
              <b-icon icon="shield-lock" class="ml-1" v-if="!isAuth"></b-icon>
            </span>
          </b-button>
          <b-button v-else @click="deleteNotepad" size="sm" variant="primary" class="position-relative z-3" v-b-modal="!isAuth ? 'not-auth-modal' : ''">
            <span v-b-tooltip.hover.bottom :title="translations[13596]">
              <b-icon icon="check"></b-icon>
              <b-icon icon="shield-lock" class="ml-1" v-if="!isAuth"></b-icon>
            </span>
          </b-button>
        </b-col>
      </b-row>
      <b-row align-h="end" no-gutters class="g-2">
        <b-col cols="auto">
          <span class="mr-2 position-relative z-3" v-b-tooltip.hover.right :title="translations[13757]">
             <b-icon icon="building"></b-icon>
          </span>
          {{ descriptionCity }}
        </b-col>
        <b-col cols="auto" class="col-auto">
          <span class="mr-2 position-relative z-3" v-b-tooltip.hover :title="translations[404]">
            <b-icon icon="geo-alt"></b-icon>
          </span>
          {{ description }}
        </b-col>
        <b-col cols="12" md="auto" class="ml-auto fs-6">
          <span class="position-relative z-3" v-b-tooltip.hover.bottom :title="translations[13758]">
            <b-icon icon="clock-history" class="mr-1"></b-icon>{{ date }}
          </span>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProfessionModule } from '@/store/modules/profession';
import { mixins } from 'vue-class-component';
import GoogleTranslate from '@/mixins/GoogleTranslate';
import { setNotebookApi, deleteNotebookApi } from '@/api/Profession';
import { NotebookModule } from '@/store/modules/notebook';
import { AppModule } from '@/store/modules/app';
import { JobType } from '@/types/ProfessionType';
import { ClustersModule } from '@/store/modules/clusters';

@Component
export default class JobCompanyItem extends mixins(GoogleTranslate) {
  @Prop({ default: 0 }) private count!: number;

  @Prop({ default: '' }) private date!: string;

  @Prop({ default: '' }) private title!: string;

  @Prop({ default: '' }) private description!: string;

  @Prop({ default: '' }) private descriptionCity!: string;

  @Prop({ default: '' }) private letter!: string;

  @Prop({ default: '' }) private shortview!: string;

  @Prop({ default: '' }) private sid!: string;

  @Prop({ default: 0 }) private id!: number;

  @Prop({ default: 0 }) private contact!: number;

  @Prop({ default: false }) private active!: boolean;

  @Prop({ default: false }) private isAuth!: boolean;

  @Prop({ default: '' }) private update!: string;

  @Prop({ default: '' }) private translateJob!: string;

  get translations() {
    return AppModule.translation;
  }

  searchJob() {
    ProfessionModule.SetJobId(this.id);
    ProfessionModule.SetJobFirm(this.descriptionCity);
    ProfessionModule.SetJobShort(this.shortview);
    ClustersModule.SetUrlIframe('');
  }

  async setNotepad() {
    if (this.isAuth) {
      NotebookModule.SetNotebookJob({
        id: this.id,
        date: this.date,
        title: this.title,
        description: this.description,
        descriptionCity: this.descriptionCity,
        letter: this.letter,
      });
      await setNotebookApi({ job_id: this.id });
    }
  }

  async deleteNotepad() {
    if (this.isAuth) {
      NotebookModule.DeleteNotebookJob(this.id);
      await deleteNotebookApi(this.id);
    }
  }
}
</script>
<style scoped lang="scss">
.translate-title {
  color: #212529;
  font-size: 14px;
  display: block;
}
</style>
